<template>
  <v-card>
    <v-card-title>
      Percentual de Acesso por Usuário
      <!-- Média Acesso X Usuário -->
    </v-card-title>
    <v-card-subtitle> Total de {{ total_usuarios }} usuários </v-card-subtitle>
    <v-card-text v-show="!showCard">
      <div class="text-center ma-12" align="center">
        <v-progress-circular
          class=""
          :indeterminate="true"
          :rotate="0"
          :size="128"
          value="Loading"
          :width="8"
          color="light-blue"
          >{{ "Loading" }}</v-progress-circular
        >
      </div>
    </v-card-text>
    <GraphicColumn
      v-if="showCard"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
    <GraphicColumnLine
      v-if="false"
      :categories="categories"
      :chartSeries="chartSeries"
    />
    <GraphicLine
      v-if="false"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "@/plugins/firebase";
export default {
  components: {
    GraphicColumn: () => import("./GraphicColumn"),
    GraphicLine: () => import("./GraphicLine"),
    GraphicColumnLine: () => import("./GraphicColumnLine")
  },

  data() {
    return {
      categories: [],
      total_usuarios: 0,
      titleY: "Média",
      titleX: "Empresa",
      chartSeries: [
        {
          name: "Usuários",
          data: [],
          tooltip: {
            valueSuffix: ""
          } //114,181,175,191,191,172,164,117
        },
        {
          name: "Percentual",
          data: [],
          dataLabels: {
            enabled: true,
            format: "{point.y:.2f}%",
            x: 5
          },
          tooltip: {
            valueSuffix: "%"
          }
        }
      ],
      showCard: false,
      date_init: "",
      date_end: "",
      isCompany: false,
      company: []
    };
  },
  computed: {
    ...mapGetters("appAnalytics", ["getFilter"]),
    ...mapGetters(["getEmpresas"])
  },
  watch: {
    getFilter(m, v) {
      this.showCard = false;
      this.init();
    }
  },

  methods: {
    async init() {
      const test_ = [
        {
          user: "57",
          percentual: "23.17",
          total_user: "246",
          empresa: "04130726000108"
        },
        {
          user: "39",
          percentual: "15.85",
          total_user: "246",
          empresa: "17323085000141"
        },
        {
          user: "26",
          percentual: "10.57",
          total_user: "246",
          empresa: "13830979000177"
        },
        {
          user: "23",
          percentual: "9.35",
          total_user: "246",
          empresa: "04926895000140"
        },
        {
          user: "16",
          percentual: "6.5",
          total_user: "246",
          empresa: "04926895000221"
        },
        {
          user: "15",
          percentual: "6.1",
          total_user: "246",
          empresa: "32950875000140"
        },
        {
          user: "14",
          percentual: "5.69",
          total_user: "246",
          empresa: "02963138000383"
        },
        {
          user: "13",
          percentual: "5.28",
          total_user: "246",
          empresa: "02963138000111"
        },
        {
          user: "11",
          percentual: "4.47",
          total_user: "246",
          empresa: "32950875000221"
        },
        {
          user: "10",
          percentual: "4.07",
          total_user: "246",
          empresa: "04897736000246"
        },
        {
          user: "9",
          percentual: "3.66",
          total_user: "246",
          empresa: "04130726000280"
        },
        {
          user: "5",
          percentual: "2.03",
          total_user: "246",
          empresa: "13830979000762"
        },
        {
          user: "5",
          percentual: "2.03",
          total_user: "246",
          empresa: "04897736000165"
        },
        {
          user: "3",
          percentual: "1.22",
          total_user: "246",
          empresa: "17323085000222"
        }
      ];
      var dataValue = [];
      var percValue = [];
      var dataCategorie = [];
      const callDate = this.getFilter;
      this.date_init = callDate.date[0];
      this.date_end = callDate.date[1];
      this.company = callDate.empresas;
      this.isCompany = callDate.withCompany;

      const app_analytics = firebase
        .functions()
        .httpsCallable("app_analytics/totalUsuarios");
      await app_analytics({
        date_init: this.date_init,
        date_end: this.date_end,
        isCompany: this.isCompany,
        company: this.company
      })
        .then(result => {
          this.total_usuarios = result.data[0].total_user;
          var tmp = [];
          this.getEmpresas.forEach((e, c) => {
            tmp = [];
            tmp = result.data.filter(a => {
              return a.empresa == e.cnpj;
            });
            dataValue.push(tmp.length > 0 ? Number(tmp[0].user) : 0);
            percValue.push(tmp.length > 0 ? Number(tmp[0].percentual) : 0);
            dataCategorie.push(e.apelido);
          });
        })
        .catch(erro => {
          console.log(erro);
        });

      Promise.all(dataValue, dataCategorie, percValue).then(a => {
        this.showCard = !this.showCard;
        this.categories = dataCategorie;
        this.chartSeries[0].data = dataValue;
        this.chartSeries[1].data = percValue;
      });
    }
  },

  created() {
    this.init();
  }
};
</script>

<style lang="scss"></style>
